module.exports = __webpack_public_path__ + "img/bydQRcode.0300eb57.png";